export default "__VITE_ASSET__Vqu8n5UY__"